var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { initialViewState } from '../view/state/view.state';
import { ViewLayout } from '../view/models/view-layout.enum';
import { ScrollModeEnum } from '../engine/models/scroll-mode.enum';
import { LoaderTypeEnum } from '../view/models/loader-type.enum';
var layoutDefaults = initialViewState.layout;
var setConfig = function (_config, _default) {
    return _config === undefined ? _default : _config;
};
var ɵ0 = setConfig;
function valueForAliases() {
    var aliases = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        aliases[_i] = arguments[_i];
    }
    // are any of the aliases true?
    if (aliases.some(function (alias) { return alias === true; })) {
        return true;
    }
    // are any of the aliases false?
    if (aliases.some(function (alias) { return alias === false; })) {
        return false;
    }
    // let downstream decide.
    return undefined;
}
function getLayoutForUIAll(enable) {
    return Object.keys(layoutDefaults).reduce(function (acc, curr) {
        if (curr === 'logo') {
            return acc;
        }
        acc[curr].enable = enable;
        return acc;
    }, __assign({}, layoutDefaults));
}
export var WidgetWiring;
(function (WidgetWiring) {
    // need to map UiIO.UIDisplayParams and URIUIConfig to UIConfig
    function convertAPIUIConfigToUIConfig(apiConfig) {
        var _a;
        // todo, split the return into a logical branch based on UiIO.UIDisplayParams.
        return _a = {
                'Layout.All': apiConfig['all']
            },
            _a[ViewLayout.Help] = valueForAliases(apiConfig['help'], apiConfig.help),
            _a[ViewLayout.Tools] = valueForAliases(apiConfig['tools'], apiConfig.tools),
            _a[ViewLayout.Toolbar] = apiConfig['tools'],
            _a[ViewLayout.Fullscreen] = valueForAliases(apiConfig['fullscreen'], apiConfig.fullscreen),
            _a[ViewLayout.Search] = valueForAliases(apiConfig['objectTree'], apiConfig.search),
            _a[ViewLayout.Audio] = apiConfig['audio'],
            _a[ViewLayout.Media] = valueForAliases(apiConfig['playPause'], apiConfig['scrubber'], apiConfig['scrubber.chapters'], apiConfig.media),
            _a[ViewLayout.Camera] = valueForAliases(apiConfig['nav'], apiConfig['cameraMode'], apiConfig['center'], apiConfig['zoomIn'], apiConfig['zoomOut'], apiConfig.nav),
            _a[ViewLayout.Pagination] = valueForAliases(apiConfig['tour'], apiConfig['tour.chapters']),
            _a[ViewLayout.Reset] = apiConfig.reset,
            _a[ViewLayout.Column] = valueForAliases(apiConfig['info'], apiConfig.info),
            _a[ViewLayout.Drawer] = valueForAliases(apiConfig['info'], apiConfig.info),
            _a[ViewLayout.LabelList] = apiConfig.labelList,
            _a[ViewLayout.ChapterList] = apiConfig.chapterList,
            _a[ViewLayout.NodeInfo] = apiConfig.anatomyDescriptions,
            _a[ViewLayout.Menu] = apiConfig.menu,
            // not controlled by API
            _a[ViewLayout.Logo] = undefined,
            _a[ViewLayout.Presenter] = undefined,
            _a['Layout.LogoIsHyperLink'] = undefined,
            _a['Layout.DrawerExpandedInitially'] = undefined,
            _a;
    }
    WidgetWiring.convertAPIUIConfigToUIConfig = convertAPIUIConfigToUIConfig;
    function convertURIUIConfigToUIConfig(uriConfig) {
        var _a;
        return _a = {},
            _a[ViewLayout.NodeInfo] = uriConfig['ui-anatomy-descriptions'],
            _a[ViewLayout.Tools] = uriConfig['ui-tools'],
            _a[ViewLayout.Toolbar] = uriConfig['ui-tools'],
            _a[ViewLayout.Media] = valueForAliases(uriConfig['ui-media'], uriConfig['ui-scrubber'], uriConfig['ui-scrubber.chapters'], uriConfig['ui-scrubber.tour']),
            _a[ViewLayout.Reset] = uriConfig['ui-reset'],
            _a[ViewLayout.Audio] = uriConfig['ui-audio'],
            _a[ViewLayout.Fullscreen] = uriConfig['ui-fullscreen'],
            _a[ViewLayout.Help] = uriConfig['ui-help'],
            _a[ViewLayout.Camera] = uriConfig['ui-nav'],
            _a[ViewLayout.Presenter] = uriConfig['ui-presenter'],
            _a[ViewLayout.Menu] = uriConfig['ui-menu'],
            _a[ViewLayout.Pagination] = uriConfig['ui-tour'],
            // handle params with aliases
            _a[ViewLayout.Search] = valueForAliases(uriConfig['ui-search'], uriConfig['ui-object-tree']),
            _a[ViewLayout.Column] = valueForAliases(uriConfig['ui-info'], uriConfig['ui-panel']),
            _a[ViewLayout.Drawer] = valueForAliases(uriConfig['ui-info'], uriConfig['ui-panel']),
            _a[ViewLayout.Logo] = valueForAliases(uriConfig['ui-bd'], uriConfig['ui-logo']),
            _a['Layout.LogoIsHyperLink'] = valueForAliases(uriConfig['ui-bd.link'], uriConfig['ui-logo.islink']),
            _a[ViewLayout.LabelList] = uriConfig['ui-label-list'],
            _a[ViewLayout.ChapterList] = uriConfig['ui-chapter-list'],
            _a['Layout.All'] = uriConfig['ui-all'],
            _a['Layout.DrawerExpandedInitially'] = uriConfig['ui-info-expand'],
            _a;
    }
    WidgetWiring.convertURIUIConfigToUIConfig = convertURIUIConfigToUIConfig;
    function createLayoutFromConfig(currentLayout, config) {
        var newLayout = JSON.parse(JSON.stringify(currentLayout));
        // respect 'all' param.
        // effect all layout except the logo
        if (config['Layout.All'] !== undefined) {
            return getLayoutForUIAll(config['Layout.All']);
        }
        newLayout.nodeInfo.enable = setConfig(config[ViewLayout.NodeInfo], layoutDefaults.nodeInfo.enable);
        newLayout.pagination.enable = setConfig(config[ViewLayout.Pagination], layoutDefaults.pagination.enable);
        newLayout.drawer.isExpandedInitially = setConfig(config['Layout.DrawerExpandedInitially'], layoutDefaults.drawer.isExpandedInitially);
        newLayout.tools.enable = setConfig(config[ViewLayout.Tools], layoutDefaults.tools.enable);
        newLayout.toolbar.enable = setConfig(config[ViewLayout.Tools], layoutDefaults.toolbar.enable);
        newLayout.media.enable = setConfig(config[ViewLayout.Media], layoutDefaults.media.enable);
        newLayout.fullscreen.enable = setConfig(config[ViewLayout.Fullscreen], layoutDefaults.fullscreen.enable);
        newLayout.help.enable = setConfig(config[ViewLayout.Help], layoutDefaults.help.enable);
        newLayout.description.enable = setConfig(config[ViewLayout.Description], layoutDefaults.description.enable);
        newLayout.camera.enable = setConfig(config[ViewLayout.Camera], layoutDefaults.camera.enable);
        newLayout.search.enable = setConfig(config[ViewLayout.Search], layoutDefaults.search.enable);
        newLayout.presenter.enable = setConfig(config[ViewLayout.Presenter], layoutDefaults.presenter.enable);
        newLayout.menu.enable = setConfig(config[ViewLayout.Menu], layoutDefaults.menu.enable);
        newLayout.logo.enable = setConfig(config[ViewLayout.Logo], layoutDefaults.logo.enable);
        newLayout.logo.isHyperLink = setConfig(config['Layout.LogoIsHyperLink'], layoutDefaults.logo.isHyperLink);
        newLayout.labelList.enable = setConfig(config[ViewLayout.LabelList], layoutDefaults.labelList.enable);
        newLayout.chapterList.enable = setConfig(config[ViewLayout.ChapterList], layoutDefaults.chapterList.enable);
        newLayout.audio.enable = setConfig(config[ViewLayout.Audio], layoutDefaults.audio.enable);
        newLayout.reset.enable = setConfig(config[ViewLayout.Reset], layoutDefaults.reset.enable);
        newLayout.column.enable = setConfig(config[ViewLayout.Column], layoutDefaults.column.enable);
        newLayout.drawer.enable = setConfig(config[ViewLayout.Drawer], layoutDefaults.drawer.enable);
        return newLayout;
    }
    WidgetWiring.createLayoutFromConfig = createLayoutFromConfig;
    function getScrollSetting(widgetConfig) {
        if (widgetConfig['disable-scroll']) {
            return ScrollModeEnum.DoNotCapture;
        }
        if (widgetConfig['disable-scroll.alert'] || widgetConfig['disable-scroll.overlay']) {
            return ScrollModeEnum.DoNotCaptureShowMessage;
        }
        return ScrollModeEnum.Capture;
    }
    WidgetWiring.getScrollSetting = getScrollSetting;
    function getUsePrintImage(widgetConfig) {
        return widgetConfig['ui-print-image'] === true;
    }
    WidgetWiring.getUsePrintImage = getUsePrintImage;
    function getLoader(widgetConfig, currentLoaderActive, currentLoaderType) {
        var isLoaderActive = widgetConfig['initial.play'] ||
            widgetConfig['initial'] ||
            widgetConfig['initial.button'] ||
            widgetConfig['initial.hand'] ||
            widgetConfig['initial.hand-hint'] ||
            currentLoaderActive;
        var loaderType = (function () {
            switch (true) {
                case widgetConfig['initial']:
                case widgetConfig['initial.button']:
                    return LoaderTypeEnum.Button;
                case widgetConfig['initial.hand']:
                case widgetConfig['initial.hand-hint']:
                    return LoaderTypeEnum.Hand;
                case widgetConfig['initial.play']:
                    return LoaderTypeEnum.Play;
                default:
                    return currentLoaderType;
            }
        })();
        return { loaderType: loaderType, isLoaderActive: isLoaderActive };
    }
    WidgetWiring.getLoader = getLoader;
})(WidgetWiring || (WidgetWiring = {}));
export { ɵ0 };
